import React, { useEffect } from "react";
import Helper from "../../common/helper";
import clsx from "clsx";
import { Add, Selected, AdvantageCheckIcon } from "../../common/icons";
import { MembershipHeader } from "./multi-card";
import ProductPricePoints from "../UI/product-price-points";
import { travellerBenefits } from "../../assets/benefits/benefits";

const isCampaign1363 = Helper.isVNCampaign();

export const AdvantagesList = ({ advantageText }) =>
  // console.log('advantageText', advantageText)
  advantageText && (
    <div className="flex gap-4">
      <div>
        <AdvantageCheckIcon className="w-6 h-6" />
      </div>
      <p className="font-montserrat font-normal text-base text-left">
        {advantageText}
      </p>
    </div>
  );

export default function SingleCard({
  benefitsTranslations,
  product,
  selectMembership,
  couponObj,
  isUserLogged,
  locationDataCurrency,
  languages,
  locationData,
  businessCategories,
}) {
  let item = product[0];
  let totalAmt = parseFloat(item.purchase_price) + parseFloat(item.tax_amt);
  let discountAmt = (
    parseFloat(item.purchase_base_price) + parseFloat(item.base_tax_amt)
  ).toLocaleString("en-US");
  let currency = item.currency_text ? item.currency_text : locationDataCurrency;
  let membershipText = item.item_group_description;
  const component_items = item.component_items || item.item_group_components;
  const foc = Helper.focLength(component_items);
  const getCoupon = Helper.checkCoupon(item, couponObj);
  const PWP = Helper.newpwpCheck(
    item,
    isUserLogged,
    locationData,
    businessCategories
  );
  const DiscoveryMembership = item.item_group_name.includes("DISCOVERY")
    ? true
    : false;
  const ExplorerMembership = item.item_group_name.includes("EXPLORER")
    ? true
    : false;
  const travellerMembership = item.item_group_name.includes("TRAVELLER")
    ? true
    : false;
  const ExplorerPlusMembership =
    item.item_group_name && item.item_group_name.includes("EXPLORER PLUS")
      ? true
      : false;
  const getVoucherDetails = Helper.voucherBenefitsChecker(locationData.country);
  const isDBS = Helper.isDBS();
  const isAMEX = Helper.isAMEX();
  const isSCB = Helper.isSCB();
  let isQbr = item.isQbr ? true : false;
  const itemName = membershipText
    .replace(/ACCOR PLUS | MEMBERSHIP/gi, "")
    .trim();
  const isBasePrice = item.priceLevel?.includes("BASE PRICE");
  let TravellerBenefits = benefitsTranslations.benefits[0].traveller;
  console.log("Benefits1", travellerBenefits);
  let ExplorerBenefits = benefitsTranslations.benefits[1].explorer;
  let ExplorerPlusBenefits = benefitsTranslations.benefits[2]["explorer plus"];
  console.log(ExplorerBenefits);
  console.log(ExplorerPlusBenefits);

  let discount =
    parseFloat(item.purchase_base_price) > parseFloat(item.purchase_price);

  function getPWPComponent(languageMessage, defaultMessage) {
    return (
      <div className="py-3">
        <span className="font-montserrat font-medium total-amount">
          {PWP.points}
        </span>
        <span className="font-montserrat font-medium uppercase">
          {" "}
          {languageMessage ? languageMessage : defaultMessage}
        </span>
      </div>
    );
  }

  useEffect(() => {
    selectMembership(item);
  }, []);

  return (
    <div
      className={clsx(
        "card flex bg-white desktop:hover:scale-105 duration-500",
        {
          selected: item.isSelected ? true : false,
        }
      )}
    >
      <div className="content-holder flex flex-col h-full">
        <div className="flex flex-col h-full p-5">
          <MembershipHeader isSelected={item.isSelected} itemName={itemName} />
          <div className="holder-text">
            <ProductPricePoints
              currency={currency}
              totalAmt={totalAmt}
              isUserLogged={isUserLogged}
              isQbr={isQbr}
              languages={languages}
              PWP={PWP}
              getCoupon={getCoupon}
              item={item}
              locationData={locationData}
              getPWPComponent={getPWPComponent}
            />
            <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.enjoyBenefits
                  ? languages.enjoyBenefits
                  : "ENJOY ACCOR PLUS UNIVERSAL BENEFITS"}
              </p>
            </div>
          </div>
          <ul className="membership-inclusions mb-5">
            {foc !== 0 && isQbr && languages.qbrFreeHotel && (
              <div className="py-3">
                <p className="font-montserrat align-middle">
                  <Add />{" "}
                  {languages.qbrFreeHotel
                    ? languages.qbrFreeHotel
                    : "Free Hotel Night"}
                </p>
              </div>
            )}
            {travellerMembership &&
              TravellerBenefits.map((advantage, id) => (
                // console.log('advantage', advantage)
                <li
                  key={id}
                  className={clsx({
                    "mt-4": id === 0,
                  })}
                >
                  <AdvantagesList
                    advantageText={advantage[benefitsTranslations.region]}
                  />
                </li>
              ))}

            {DiscoveryMembership && (
              <React.Fragment>
                {languages.discoveryMembershipCustomMessageList1 ? (
                  <li className="inclusion-list flex items-center">
                    <AdvantagesList
                      advantageText={
                        languages?.discoveryMembershipCustomMessageList1 ||
                        "Earn 1,000 Discovery Dollars"
                      }
                    />
                  </li>
                ) : (
                  <></>
                )}

                {languages.discoveryMembershipCustomMessageList2 ? (
                  <li className="inclusion-list flex items-center">
                    <AdvantagesList
                      advantageText={
                        languages?.discoveryMembershipCustomMessageList2 ||
                        "10% savings on membership(RRP $498)"
                      }
                    />
                  </li>
                ) : (
                  <></>
                )}

                <li className="inclusion-list flex items-center">
                  <AdvantagesList
                    advantageText={
                      languages?.discoveryMembershipMessage ||
                      "Amazing cruise, tour and wine offers worldwide"
                    }
                  />
                </li>
              </React.Fragment>
            )}
            {/* {foc !== 0 && (
              <li className="inclusion-list flex items-center">
                {foc > 1 ? (
                  <AdvantagesList
                    advantageText={
                      languages?.productFocAvailableMultipleMessage ||
                      "Stay Plus complimentary nights"
                    }
                  />
                ) : (
                  <AdvantagesList
                    advantageText={
                      languages?.productFocAvailableSingleMessage ||
                      "Complimentary night stay at participating hotels"
                    }
                  />
                )}
              </li>
            )} */}
            {ExplorerMembership &&
            isBasePrice &&
            !ExplorerPlusMembership &&
            !isQbr &&
            languages.productBonusRewardPoints ? (
              <li className="inclusion-list flex items-center">
                <AdvantagesList
                  advantageText={
                    languages?.productBonusRewardPoints ||
                    "Bonus 2,000 Reward Points (For a limited time)"
                  }
                />
              </li>
            ) : (
              <></>
            )}
            {foc !== 0 &&
              !isQbr &&
              !isSCB &&
              ExplorerMembership &&
              ExplorerBenefits?.map(
                (
                  advantage,
                  id // non-qbr
                ) => (
                  <li
                    key={id}
                    className={clsx({
                      "mt-4": id === 0,
                    })}
                  >
                    <AdvantagesList
                      advantageText={advantage[benefitsTranslations.region]}
                    />
                  </li>
                )
              )}
            {foc !== 0 &&
              !isQbr &&
              ExplorerPlusMembership &&
              ExplorerPlusBenefits.map(
                (
                  advantage,
                  id // non-qbr
                ) => (
                  <li
                    key={id}
                    className={clsx({
                      "mt-4": id === 0,
                    })}
                  >
                    <AdvantagesList
                      advantageText={advantage[benefitsTranslations.region]}
                    />
                  </li>
                )
              )}
            {DiscoveryMembership &&
              getVoucherDetails[1].discovery &&
              !isAMEX && (
                <li>
                  <AdvantagesList
                    advantageText={
                      languages?.productVoucherBenefitsDiscovery ||
                      " Exclusive dining and accommodation discount vouchers"
                    }
                  />
                </li>
              )}
            {ExplorerMembership && getVoucherDetails[0].explorer && !isAMEX && !isSCB && (
              <li>
                <AdvantagesList
                  advantageText={
                    languages?.productVoucherBenefitsExplorer ||
                    " Exclusive dining and accommodation discount vouchers"
                  }
                />
              </li>
            )}
            {ExplorerPlusMembership &&
              getVoucherDetails[2].explorer_plus &&
              !isAMEX && (
                <li className="inclusion-list flex items-center">
                  <AdvantagesList
                    advantageText={
                      languages?.productVoucherBenefitsExplorer ||
                      " Exclusive dining and accommodation discount vouchers"
                    }
                  />
                </li>
              )}
            {ExplorerMembership && isCampaign1363 && (
              <li className="flex gap-4">
                <div>
                  <AdvantageCheckIcon className="w-6 h-6" />
                </div>
                <p className="font-montserrat font-normal text-base text-left">
                  Cash voucher package worth VND 2,000,000 when paying with a
                  VISA Signature or VISA Infinite card. Terms and Conditions
                  apply.
                </p>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
